import { render, staticRenderFns } from "./EvernymInvitation.vue?vue&type=template&id=60120eaf&scoped=true&"
import script from "./EvernymInvitation.vue?vue&type=script&lang=js&"
export * from "./EvernymInvitation.vue?vue&type=script&lang=js&"
import style0 from "./EvernymInvitation.vue?vue&type=style&index=0&id=60120eaf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60120eaf",
  null
  
)

export default component.exports